/* eslint-disable array-callback-return */

import React, {useState, useEffect, Fragment, useRef} from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import Checkbox from '@material-ui/core/Checkbox';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import LoadingTable from './LoadingTable';
import LicenseRestriction from 'views/Components/License';
import FormControl from '@material-ui/core/FormControl';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Switch from '@material-ui/core/Switch';

import Link from 'redux-first-router-link';

import { useInView } from 'react-intersection-observer';

const MAX_BATCH_COUNT = 50;

const useStyles = makeStyles((theme) => ({
  actionsContainer: {
    display: 'flex',
    paddingBottom: 20,
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  primaryActionsContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-end',
    '@media (max-width: 1120px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'space-between'
    },
  },
  primaryActionContainer: {
    '@media (max-width: 1120px)': {
      marginTop: -15,
      marginBottom: 30
    },
  },
  searchFieldContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  toolbarActionButton: {
    margin: '0 10px',
    fontWeight: 'bold',
    padding: '9px 18px',
    textTransform: 'none',
    color: theme.palette.text.primary,
  },
  multiSelectButton: {
    zIndex: 999,
  },
  multiSelectAlert: {
    height: 30,
    marginLeft: 10,
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.info.main,
    '&.attention': {
      animation: 'scale-shake 1s linear'
    },
    '& span': {
      color: theme.palette.primary.main
    },
  },
  alignRightAction: {
    position: 'absolute',
    right: 0
  },
  tableOuterContainer: {
  },
  paginationContainer: {
    height: 50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  multiselectContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  multiSelectionText: {
    fontSize: '0.875rem',
    margin: `0 !important`
  },
  table: {
    minWidth: 650,
    borderRadius: 5,
    boxShadow: 'none',
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper
  },
  tableRow: {
    cursor: 'pointer'
  },
  tableRowEmpty: {
    backgroundColor: theme.palette.background.paper,
  },
  actions: {
    padding: theme.spacing(0.5)
  },
  tableSortLabel: {
    fontWeight: 'bold'
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  titleBar: {
    width: 'fit-content',
    flex: '1 1 100%',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  toolBar: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  tableCell: {
    '& pre': {
      whiteSpace: 'pre-wrap',
      color: theme.palette.text.primary
    },
    '&:hover': {
      background: theme.palette.action.hover,
    },
    '&:hover $tableCellAction': {
      display: 'initial'
    }
  },
  tableCellEmpty: {
    color: theme.palette.text.secondary,
    textAlign: 'center',
    paddingTop: 40,
    paddingBottom: 40,
  },
  tableCellAction: {
    display: 'none'
  },
  newSearchField: {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper
  },
  linkLi: {
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    '& a': {
      color: theme.palette.text.primary,
      paddingTop: 6,
      paddingBottom: 6,
      paddingRight: 16,
      paddingLeft: 16,
      textDecoration: 'none',
      width: '100%'
    }
  }
}));


const renderValue = (column, model) => {
  const { field, lookup, renderValue } = column
  if (renderValue) {
    return renderValue(column, model)
  } else if (lookup) {
    return lookup[model[field]]
  } else if(typeof(model[field]) === 'string' && model[field].includes('{')){
    return <pre>{model[field]}</pre>
  }
  else {
    return model[field]
  }
}

const isRuleEnabled = (rule) => rule.status===1 || rule.status===101 //1=enabled, 101=pending_enabled

function SimpleRow(props) {
  const { handleSelect, selected = false, hasMultiSelect = false, switchProps} = props
  const classes = useStyles()

  const onClick = (event, model, fieldName) => {
    if(props.onClick){
      props.onClick(event, model, fieldName)
    }
  }

  const handleOnChange = () => {
    handleSelect()
  }

  const handleSwitchOnChange = (model) => {
    props.handleSwitchToggle(model)
  }

  return (
    <TableRow key={props.model.id} className={classes.tableRow}>
      {hasMultiSelect &&<TableCell className={classes.tableCell}>
        <Checkbox
          color={'primary'}
          checked={selected}
          onChange={handleOnChange}
          inputProps={{ 'value': props.model.id }}
        />
      </TableCell>}
      {switchProps &&<TableCell className={classes.tableCell} style={{width: "90px"}}>
        <Tooltip placement="right" title={isRuleEnabled(props.model) ? 'Disable this rule' : 'Enable this rule'}>
          <Switch
            color={'primary'}
            disabled={!switchProps.user.superadmin && !switchProps.user.orgRoles.some(r=>r.orgId===switchProps.orgId && r.roleId===10)}
            checked={isRuleEnabled(props.model)}
            onChange={()=>handleSwitchOnChange(props.model)}
            inputProps={{ 'value': props.model.id }}
            datacy={`rulesSwitchBtn${isRuleEnabled(props.model) ? 'Enabled':'Disabled'}`}
          />
        </Tooltip>
      </TableCell>}
      {props.columns && props.columns.map((column) => (
        <TableCell key={column.field} onClick={(event)=>onClick(event, props.model, column.field)} style={column.css} className={classes.tableCell} datacy="simpleTableCell">
          {column.icon ? column.icon : null}
          {renderValue(column, props.model)}
        </TableCell>
      ))}
      {props.actions && (
      <TableCell key="actions" align="right" style={{width: "90px"}}>
        {props.actions && props.actions.map(action => (
          <Tooltip key={action.tooltip} title={action.tooltip}>
            <IconButton datacy={`simpleTableRowIconButton`} className={classes.actions} color={action.color|| 'default'} onClick={(e)=>action.onClick(e, props.model, props.columns)}>
              <action.icon fontSize="small" />
            </IconButton>
          </Tooltip>
        ))}
      </TableCell>
      )}
    </TableRow>
  )
}

export default function SimpleTable(props) {
  const { isFetching, searchData, isNorthStar, emptyText, licenseRestriction } = props
  
  const classes = useStyles();

  const [selectedTableData, setSelectedTableData] = useState([])
  const [tableData, setTableData] = useState(props.data)
  const [resultsCount, setResultsCount] = useState(props.resultsCount)
  const [anchorEl, setAnchorEl] = useState(null)
  const [multiSelectAnchorEl, setMultiSelectAnchorEl] = useState(null)
  const [count, setCount] = useState(props.data ? props.data.length : 0)
  const [page, setPage] = useState(0)
  const [order, setOrder] = useState('asc')
  const [orderBy, setOrderBy] = useState('name')
  const [textFilter, setTextFilter] = useState('')
  const [contextMenu, setContextMenu] = useState({})
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [textIndex, setTextIndex] = useState([])
  const [idIndex, setIdIndex] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [currentDataLength, setCurrentDataLength] = useState(0) /* eslint-disable-line */
  const [limitIsReached, setlimitReached] = useState(false)
  const [contextMenuSwitchTxt, setContextMenuSwitchTxt] = useState('')

  useEffect(() => {
    if(selectedTableData.length)
      setSelectedTableData([])
  }, [isFetching]) /* eslint-disable-line */

  useEffect(() => {
    if(props.initialOrderBy){
      const [ initialOrderByProperty, initialOrder ] =  props.initialOrderBy
      setOrder(initialOrder)
      setOrderBy(initialOrderByProperty)
    }
  }, [props.initialOrderBy])
  
  useEffect(() => {
    if (props.data) {
      setCount(props.data ? props.data.length : 0)
      buildTextIndex(props.data)
    }
    if( (props.data.length - (page * rowsPerPage)) <= 0 ) {
      const backPage = Math.floor(props.data.length /  rowsPerPage) - 1
      setPage(backPage < 0 ? 0 : backPage)
    }
    setTableData(props.data)
    setFilteredData(props.data)
    setResultsCount(props.resultsCount)
    setCurrentDataLength(filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).length)
  }, [props.data]) /* eslint-disable-line */

  useEffect(() => {
    const filterData = tableSort(tableData, getComparator(order, orderBy))
      .filter((model) => idIndex.indexOf(model.id) >= 0)
    setFilteredData(filterData)
    setCount(filterData.length)
    const res = filterData.length === 1 ? filterData.length + " result" : filterData.length + " results"
    setResultsCount(res)
    setPage(0)
    setCurrentDataLength(filteredData.slice(0 * rowsPerPage, 0 * rowsPerPage + rowsPerPage).length)
  }, [idIndex, orderBy, order]) /* eslint-disable-line */

  useEffect(() => {
    let data = searchData ? searchData : ''
      setTextFilter(data)
      updateFilterIds(data, textIndex)
  }, [searchData, textIndex]) /* eslint-disable-line */

  const buildTextIndex = (data) => {
    const _textIndex = []

    const searchColumns = props.columns.filter(column=>column.searchable)

    data.map(model => {
      const _text = searchColumns.map(column => {
        const value = renderValue(column, model) || ''
        if(typeof(value) === 'string')
          return value.toLowerCase()
        return value
      })
      _textIndex.push({
        id:model.id,
        textIndex:_text.join(" ")
      })
    })
    setTextIndex(_textIndex)
    updateFilterIds(textFilter, _textIndex)
  }

  const handleTextFilterChange = (event) => {
    var _textFilter = ''
    if(event){
       _textFilter = event.target.value
    } 

    // set the filter text from user input, or clear
    setTextFilter(_textFilter)

    // set the ids of models found be searchable text
    updateFilterIds(_textFilter, textIndex)
  }

  const updateFilterIds = (textFilter, textIndex) => {

    const _idIndex = []
    const _filters = textFilter.toLowerCase().split(' ').filter(i=>i)
    if (_filters.length === 0){
      textIndex.map(i=> _idIndex.push(i.id))
    } else {
      textIndex.map(index => {
        var found = true
        _filters.map( _textFilter => {
          if (index.textIndex.indexOf(_textFilter) === -1) {
            found = false
          }
        })
        if (found) {
          _idIndex.push(index.id)
        }
      })

    }
    setIdIndex(_idIndex)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setCurrentDataLength(filteredData.slice(newPage * rowsPerPage, newPage * rowsPerPage + rowsPerPage).length)
  };

  const handleChangeCount = (event) => {
    const newRowsPerPage = event.target.value
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    setCurrentDataLength(filteredData.slice(0 * newRowsPerPage, 0 * newRowsPerPage + newRowsPerPage).length)
  };

  const _comparator = (a, b, orderBy) => {
    const column = props.columns.find(c=>c.field===orderBy) || {}
    var vA = a[orderBy]
    var vB = b[orderBy]

    if (column.lookup){
      if(typeof column.lookup[a[orderBy]] === 'string'){
        vA = column.lookup[a[orderBy]];
      }
      if(typeof column.lookup[b[orderBy]] === 'string'){
        vB = column.lookup[b[orderBy]];
      }
    }

    //convert all strings to same case (ie lowercase) to ensure proper/case-insensitive comparison
    if(typeof vA === 'string'){
      vA = vA.toLowerCase()
    }
    if(typeof vB === 'string'){
      vB = vB.toLowerCase()
    }

    return {vA, vB}
  }

  const descComparator = (a, b, orderBy) => {
    const comp = _comparator(a, b, orderBy)
    if (comp.vA > comp.vB) { return -1; }
    if (comp.vB > comp.vA) { return  1; }
    return 0;
  }
  
  const ascComparator = (a, b, orderBy) => {
    const comp = _comparator(a, b, orderBy)
    if (comp.vA < comp.vB) { return -1; }
    if (comp.vB < comp.vA) { return  1; }
    return 0;
  }

  const getComparator = (order, orderBy) => {
    return order === 'desc' ? (a, b) => descComparator(a, b, orderBy) : (a, b) => ascComparator(a, b, orderBy)
  }

  const tableSort = (array, comparator) => {
    if (array) {
      const stabilizedThis = array.map((el, index) => [el, index]);
      // given the 'sort' method behaves unpredictably
      // on browser, guarantee order prior to sorting
      stabilizedThis.sort((a, b) => a[1] < b[1]).sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order
        return a[1] - b[1];
      });
      return stabilizedThis.map((el) => el[0]);
    }else{
      return []
    }
  }

  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };


  const handleClick = (event, model, fieldName) => {
    if(props.rowClick)
      props.rowClick(model)
    if(props.contextMenuItems){
      if(props.rowToggleSwitches){
        //if current user has permissions to enable/disable, show context menu
        if(props.rowToggleSwitches.user.superadmin || props.rowToggleSwitches.user.orgRoles.some(r=>r.orgId===props.rowToggleSwitches.orgId && r.roleId===10)){
          isRuleEnabled(model) ? setContextMenuSwitchTxt('Disable this rule') : setContextMenuSwitchTxt('Enable this rule')
          setContextMenu({anchorEl: event.currentTarget, model, fieldName})
        } else { //else, just show the details modal
          props.handleViewDetails(model)
        }
      } else {
        setContextMenu({anchorEl: event.currentTarget, model, fieldName})
      }
    }
  };

  const menuClick = (menuItem) => {
    menuItem.onClick(contextMenu)
    setContextMenu({});
  }

  const toggleExportMenu = (e) => {
    setAnchorEl(e.currentTarget)
  }

  const toggleMultiSelectMenu = (e) => {
    setMultiSelectAnchorEl(e.currentTarget)
  }

  const handleSelectAll = () => { /* eslint-disable-line */
    const newSelectedTableData = filteredData.map(data => data.id)
    setSelectedTableData(newSelectedTableData)
  }

  const myScrollToAlertRef = useRef(null)

  const [inViewRef, inView] = useInView()

  const executeScroll = () => myScrollToAlertRef.current.scrollIntoView({ block: 'start',  behavior: 'smooth' })

  const handleLimitReached = () => {
    //if Alert is in the viewport already, update the setlimitReach state
    //which will add the .attention class to the Alert applying the custom css animation to make it flash
    //drawing the user's attention to it, hopefully :)
    if(inView){
      setlimitReached(true)
      //then just remove the class right after the animation is done,
      //so this process can repeat again if the user tries to click a checkbox again
      setTimeout(function(){ setlimitReached(false) }, 1000)
    }
    //otherwise (if it's not already in viewport), scroll it into view first
    //then do the state/class changes
    else{
      executeScroll()
      //add a slight delay before applying the .attention class this time
      //to ensure that it has time to scroll the Alert into view first
      setTimeout(function(){ setlimitReached(true) }, 500)
      setTimeout(function(){ setlimitReached(false) }, 1500)
    }
  }

  const getCurrentlyShownData = () => filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(data => data.id)
  
  const handleSelectCurrentPage = () => {
    //if the "select all" checkbox is already checked here when the user clicks it,
    //then we ignore this limitReached logic
    //if it's NOT already checked,
    //then we need to see if the maximum limit has been hit
    //and if it has reached the limit, then we need to handle it (show the Alert)
    if(!isTableCheckboxChecked() && selectedTableData.length === MAX_BATCH_COUNT){
      handleLimitReached()
      return
    }
    //then whether the limit has been reached or not
    //we need to update the state item that we're using to track which items have been selected
    const currentlyShownData = getCurrentlyShownData()
    const boxesSelectedOnOtherPages = selectedTableData.filter(id => currentlyShownData.indexOf(id) === -1)
    //if the user is UNchecking the "select all",
    //then we only want the checked boxes from all the other pages (if any)
    //else the box is not yet checked, meaning the user is checking "select all"
    //so we update our state item with all the checked boxes on the current page
    //as well as any that are already checked on all other pages
    const newSelectedTableData = isTableCheckboxChecked() ? boxesSelectedOnOtherPages : boxesSelectedOnOtherPages.concat(currentlyShownData)
    setSelectedTableData(newSelectedTableData)
  }

  const isTableCheckboxChecked = () => {
    const currentlyShownData = getCurrentlyShownData()
    const boxesSelectedOnCurrentPage = currentlyShownData.filter(id => selectedTableData.includes(id))
    //if at least one box has been checked on at least one page
    //AND all of the current page data equals the currently selected boxes on the current page
    //then return true to ensure the "select all" checkbox as checked
    //else return false to ensure the "select all" checkbox is NOT checked
    return selectedTableData.length > 0 && currentlyShownData.length === boxesSelectedOnCurrentPage.length
  }

  const handleSelectItem = itemId => {
    let itemPresent = isItemSelected(itemId)
    if(!itemPresent && selectedTableData.length === MAX_BATCH_COUNT){ // TODO: delete when our API supports batch resolutions
      handleLimitReached()
      return
    }
    let newSelectedTableData = !!itemPresent ? [...selectedTableData].filter(id => id !== itemId) : [...selectedTableData].concat([itemId])
    setSelectedTableData(newSelectedTableData)
  }

  const isItemSelected = itemId => {
    return selectedTableData.find(id => { return itemId === id })
  }

  const getToolbarButton = () => {
    return props.toolbarActions && props.toolbarActions.filter(a => !a.isPrimary).map(action => (
      <Button
        key={action.tooltip}
        onClick={action.onClick}
        datacy={'simpleTableToolbarBtn'}
        className={!!action.alignRight ? [classes.toolbarActionButton, classes.alignRightAction] : classes.toolbarActionButton}
        startIcon={action.icon && <action.icon />}
        disabled={action.disabled ? action.disabled : false}
      >
        {action.tooltip}
      </Button>
    ))
  }

  return (
    <div ref={myScrollToAlertRef}>
      {(isNorthStar && !isFetching) && 
        <div className={classes.actionsContainer}>
          <div className={classes.primaryActionsContainer}>
            {props.toolbarActions && props.toolbarActions.filter(a => a.isPrimary).map((action, idx) => (
              <div className={classes.primaryActionContainer} key={idx}>
                {action.component}
              </div>
            ))}
            <div className={classes.searchFieldContainer}>
              <TextField
                value={textFilter}
                datacy="simpleTableSearch"
                onChange={handleTextFilterChange}
                className={classes.newSearchField}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                  disableUnderline: true
                }}
              />
              {licenseRestriction ?
                <LicenseRestriction requires={licenseRestriction}>
                  {getToolbarButton()}
                </LicenseRestriction>
              :
                getToolbarButton()
              }
            </div>
          </div>
          {props.moreMenuItems && 
            <div>
              <IconButton onClick={toggleExportMenu} aria-controls={'simple-menu'} datacy={'moreMenuItemsBtn'}>
                <MoreHorizIcon />
              </IconButton>
              <Menu
                keepMounted
                id="simple-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                disableScrollLock={true}
                onClose={() => setAnchorEl(null)}
              >
                {props.moreMenuItems.map((item, idx) => {
                  if(item.licenseRestriction){
                    return (
                      <LicenseRestriction requires={item.licenseRestriction}>
                        <MenuItem 
                          key={idx}
                          onClick={() => {
                            item.onClick()
                            setAnchorEl(null)
                          }}
                          datacy={item.datacy}
                        >
                          {item.label}
                        </MenuItem>
                      </LicenseRestriction>
                    )
                  }
                  return(
                    <MenuItem 
                      key={idx}
                      onClick={() => {
                        item.onClick()
                        setAnchorEl(null)
                      }}
                    >
                      {item.label}
                    </MenuItem>
                  )
                })}
                {props.exportData && <Divider orientation="horizontal" />}
                {props.exportData && <MenuItem onClick={()=> props.exportData('csv')}>Export CSV</MenuItem>}
                {props.exportData && <MenuItem onClick={()=> props.exportData('jsonl')}>Export JSON-L</MenuItem>}
                {props.exportData && <MenuItem onClick={()=> props.exportData('json')}>Export JSON</MenuItem>}
              </Menu>
            </div> 
          }
        </div>
      }
      {props.filterComponent && props.filterComponent}
      <div className={classes.paper}>
        {!isNorthStar && <Toolbar variant="dense" className={classes.toolBar}>
          <Grid container alignItems="center" className={classes.titleBar}>
            <Typography variant="h6" id="tableTitle" component="div">
              {props.title || ''}
            </Typography>
            <Divider orientation="vertical" flexItem />
            {props.toolbarActions && props.toolbarActions.map(action => (
              <Button
                key={action.tooltip}
                size="small"
                color="primary"
                onClick={action.onClick}
                startIcon={<action.icon />}
                datacy={'simpleTableToolbarBtn'}
              >
              {action.tooltip}
              </Button>
            ))}
          </Grid>

          <FormControl className={classes.searchField}>
            <TextField
              onChange={handleTextFilterChange}
              size="small"
              label="Search"
              value={textFilter}
              datacy="simpleTableSearch"
              InputProps={{
                endAdornment:(
                  <InputAdornment position="end">
                    <IconButton edge="end" onClick={()=>handleTextFilterChange()}>
                      <CloseIcon />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </FormControl>
        </Toolbar>}
        <Menu
          id="context-menu"
          anchorEl={contextMenu.anchorEl}
          keepMounted
          open={Boolean(contextMenu.anchorEl)}
          onClose={()=>setContextMenu({})}
          disableScrollLock={true}
        >
          {props.contextMenuItems && props.contextMenuItems.map((menuItem, idx) => {
            const itemText = menuItem.detectionRule ? contextMenuSwitchTxt : menuItem.text
            if (menuItem.link) {
              return (
                <MenuItem key={idx} className={classes.linkLi} datacy={menuItem.datacy}>
                  <Link to={menuItem.link} target={'_blank'} onClick={()=>menuClick(menuItem)}>
                    {itemText}
                  </Link>
                </MenuItem>
              )
            } else {
              return (
                <MenuItem key={idx} onClick={()=>menuClick(menuItem)} datacy={menuItem.datacy}>
                  {itemText}
                </MenuItem>
              )
            }
          })}
        </Menu>
        {isFetching ?
          <LoadingTable isMaterial />
        :
        <div className={classes.tableOuterContainer}>
          <div className={classes.paginationContainer}>
            {selectedTableData.length<=0 && resultsCount}
            {!!selectedTableData.length ? 
              <div className={classes.multiselectContainer}>
                <Button
                  onClick={toggleMultiSelectMenu}
                  className={classes.multiSelectButton}
                  endIcon={<ArrowDropDownIcon/>}
                >
                  Resolve selected as
                </Button>
                <Menu
                  keepMounted
                  id="simple-menu"
                  anchorEl={multiSelectAnchorEl}
                  open={Boolean(multiSelectAnchorEl)}
                  disableScrollLock={true}
                  onClose={() => setMultiSelectAnchorEl(null)}
                >
                  {props.multiselectOptions.map((option, idx) => (
                    <MenuItem 
                      key={idx}
                      onClick={() => {
                        props.handleMultiSelection(option, selectedTableData)
                        setMultiSelectAnchorEl(null)
                      }}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </Menu>
                {/* {currentDataLength === selectedTableData.length ? // if amount selected matches what's currently displayed in table
                  <Alert
                    icon={false}
                    className={classes.multiSelectAlert}
                    action={currentDataLength === filteredData.length ? null :
                      <Button color={'inherit'} size={'small'} onClick={handleSelectAll}>
                        Select all {filteredData?.length || ''} findings
                      </Button>
                    }
                  ><span>
                    {currentDataLength === filteredData.length ? `All ${currentDataLength} findings are selected.`
                    : `All ${currentDataLength} findings on this page are selected.`}
                    </span>
                  </Alert> 
                : selectedTableData.length === filteredData.length ? // if amount selected matches what's currently available across all pages
                  <Alert icon={false} className={classes.multiSelectAlert}>
                    <span>All {filteredData.length} findings are selected.</span>
                  </Alert>
                : null} */}
                
                {/* 
                  TODO: the commented out code above will be 
                  used when our API supports batch resolutions
                  and the Alert below will be deleted
                */}

                {selectedTableData.length === MAX_BATCH_COUNT && <Alert ref={inViewRef} icon={false} className={limitIsReached===true ? classes.multiSelectAlert+' attention' : classes.multiSelectAlert}>
                  <span>Maximum number of items ({MAX_BATCH_COUNT}) selected</span>
                </Alert>}
              </div>
            : <div />}
            <TablePagination
              rowsPerPageOptions={[10, 25, 50]}
              component="div"
              count={count}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeCount}
            />
          </div>
          <TableContainer className={classes.table}>
            <Table aria-label="simple table" datacy="simpleTable">
              <TableHead>
                <TableRow>
                  {/* 
                    TODO: code below will be used
                    when our API supports batch resolutions 
                  */}
                  
                  {!!props.multiselectOptions && <TableCell>
                    <Checkbox
                      color={'primary'}
                      onChange={handleSelectCurrentPage}
                      checked={isTableCheckboxChecked()}
                      inputProps={{
                        'aria-label': 'Select all'
                      }}
                    />
                  </TableCell>}


                  
                  {!!props.rowToggleSwitches && <TableCell></TableCell>}
                  
                  {props.columns && props.columns.map((column) => (
                    <TableCell
                      key={column.field}
                      align={column.type === 'number' ? 'right' : 'left'}
                      sortDirection={orderBy === column.field ? order : false}
                    >
                      {column.title && (
                        <TableSortLabel
                          className={classes.tableSortLabel}
                          active={orderBy === column.field}
                          direction={orderBy === column.field ? order : 'asc'}
                          onClick={createSortHandler(column.field)}
                        >
                          {column.title}
                          {orderBy === column.field ? (
                            <span className={classes.visuallyHidden}>
                              {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </span>
                          ) : null}
                        </TableSortLabel>
                      )}
                    </TableCell>
                  ))}
                  { props.actions && <TableCell key="actions" align="right" /> }
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData.length ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((model, index) => (
                    <SimpleRow 
                      index 
                      key={index} 
                      model={model} 
                      columns={props.columns} 
                      actions={props.actions} 
                      onClick={handleClick} 
                      selected={!!isItemSelected(model.id)}
                      hasMultiSelect={!!props.multiselectOptions}
                      handleSelect={() => handleSelectItem(model.id)}
                      switchProps={props.rowToggleSwitches}
                      handleSwitchToggle={props.handleSwitchToggle}
                    />
                  )
                ) :  <Fragment /> }
                {!filteredData.length && emptyText ? (
                  <TableRow className={classes.tableRowEmpty}>
                    <TableCell datacy={`emptyTableCell`} className={classes.tableCellEmpty} colSpan={1000}>
                      {emptyText}
                    </TableCell>
                  </TableRow>
                ) : <Fragment /> }
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeCount}
          />
        </div>
        }
      </div>
    </div>
  );
}

SimpleTable.propTypes = {
  isFetching: PropTypes.bool,
  emptyText: PropTypes.string,
};

SimpleTable.defaultProps = {
  data: [],
  columns: [],
  isFetching: false,
  emptyText: null,
};

SimpleRow.propTypes = {
  model: PropTypes.object.isRequired,
  columns: PropTypes.array.isRequired
};
